<script lang="ts">
  import FieldHint from '$lib/components/drawers/client/integrations/FieldHint.svelte';

  type SyncSettings = Record<string, boolean>;
  type SyncSetting = {
    key: string;
    label: string;
  };

  export let settings: SyncSettings;
  export let customSettings: SyncSetting[] = [];
  export let disabled = false;
  export let isSaving = false;
  export let onChange: (() => void | Promise<void>) | undefined;

  const commonSettings: SyncSetting[] = [
    { key: 'canSync', label: 'Can Sync' },
    { key: 'canInvoicePost', label: 'Can Invoice Post' },
    { key: 'canExpenseClaimPost', label: 'Can Expense Claim Post' },
    { key: 'syncTaxCodes', label: 'Tax Codes' },
    { key: 'syncSuppliers', label: 'Suppliers' },
    { key: 'syncGeneralLedgerCodes', label: 'GL Codes' },
    { key: 'syncBudgets', label: 'Budgets' },
    { key: 'syncSpends', label: 'Spends' },
  ];

  $: displayedSettings = [...commonSettings.filter((setting) => setting.key in settings), ...customSettings];
</script>

<section class="space-y-4">
  <div class="flex items-center justify-between gap-3 border-b pb-2">
    <h5 class="text-sm font-semibold text-gray-700">Entity Sync Settings</h5>
    {#if onChange}
      <span class="text-xs text-gray-500">{isSaving ? 'Saving...' : 'Changes save automatically'}</span>
    {/if}
  </div>
  <FieldHint text="Choose which data types this entity can sync or post. Changes are saved automatically." />
  <div class="flex flex-wrap gap-x-5 gap-y-2">
    {#each displayedSettings as setting (setting.key)}
      <label class="flex cursor-pointer items-center gap-2 text-sm">
        <input type="checkbox" bind:checked={settings[setting.key]} class="rounded" disabled={disabled || isSaving} on:change={() => onChange?.()} />
        {setting.label}
      </label>
    {/each}
  </div>
</section>
